<mat-drawer-container class="drawer-wrapper">
    <div #drawerContainer>
        <mat-drawer #drawer class="drawer-box" [mode]="mode()" [position]="position()" [opened]="opened()">
            <ng-content></ng-content>
            <i href="#" class="icon icon-cross" (click)="close()"></i>
        </mat-drawer>
    </div>
</mat-drawer-container>